<pw-view-title>{{'incidents.incidentsList.incidentsFor' | translate}} {{(position$ | async)?.NAME}}</pw-view-title>

<pw-view-actions>
  <button mat-icon-button (click)="openSearchDialog()">
    <mat-icon>find_in_page</mat-icon>
  </button>
</pw-view-actions>


<div class="ps-grid-2-col">

  <ng-container *ngIf="(incidents | async).length > 0; else showLoading">
    <mat-card *ngFor="let incident of (incidents | async)" [class]="getStatusStyle(incident)"
              style="max-width: 100%">
      <mat-card-header>
        <mat-card-title>
          {{incident.SNR}} {{incident.ORDERNR}} {{incident.DATUMERSTELLUNG | date: 'short'}}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="ps-grid-3-col">
          <div>{{'incidents.incidentsList.category' | translate}}: {{incident.CATEGORYNAME}}</div>
          <div>{{'incidents.incidentsList.error' | translate}}: {{incident.ERRORNAME}}</div>
          <div>{{'incidents.incidentsList.priority' | translate}}: {{incident.PRIONAME}}</div>
          <div>{{'incidents.incidentsList.status' | translate}}: {{incident.STATUSNAME}}</div>
          <div>{{'incidents.incidentsList.affectedParts' | translate}}: {{incident.PARTS_AFFECTED}}</div>
        </div>

        <div>
          <mat-divider style="margin: 8px"></mat-divider>
        </div>
        <div class="incident-description" matTooltip="{{incident.PROBLEM_BESCHREIBUNG}}">
          {{incident.PROBLEM_BESCHREIBUNG}}
        </div>
      </mat-card-content>
      <mat-card-actions align="end">
        <button color="primary" mat-button matTooltip="{{'incidents.incidentsList.accept' | translate}}" *ngIf="isOpen(incident)"
                (click)="acceptIncident(incident)">
          <mat-icon>thumb_up_alt</mat-icon>
        </button>
        <button color="primary" mat-button matTooltip="Info"
                routerLink="/orders/{{(order$ | async)?.OBJECT_ID}}/{{(position$ | async)?.OBJECT_ID}}/incidents/{{incident.OBJECT_ID}}">
          <mat-icon>info</mat-icon>
        </button>
        <!-- https://tebisproleis.atlassian.net/browse/BMWPT-1759
        <button *ngIf="incident.EXT_QS_CHANGE_NOTICE" color="primary" mat-button matTooltip="{{'incidents.incidentsList.changesAck' | translate}}"
                (click)="acceptNotice(incident)">
          <mat-icon>task_alt</mat-icon>
        </button>
        -->
      </mat-card-actions>
    </mat-card>
  </ng-container>

  <ng-template #showLoading>
    <mat-card>
      <mat-card-content *ngIf="!(cvs.isLoading | async)">{{'incidents.incidentsList.noIncidents' | translate}}
      </mat-card-content>
      <mat-card-content *ngIf="cvs.isLoading | async">{{'incidents.incidentsList.incidentsLoading' | translate}}</mat-card-content>
    </mat-card>
  </ng-template>
</div>
